"use client";

import { AlertTriangle, Store } from "lucide-react";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

import { Button } from "../ui/button";
import GenericAvatarFallback from "../GenericAvatarFallback";
import { Icons } from "../icons/icons";
import Link from "next/link";
import RegisterDownloadButton from "../RegisterDownloadButton";
import SettingMenu from "../SettingsMenu";
import ThemeChooser from "../ThemeChooser";
import { cn } from "@/lib/utils";
import { useDataContext } from "../../app/_context";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { useWPUser } from "@/app/_authContext";

export default function RightNavigationMenu() {
  const { shareMenuOpen, currentProjectInfo } = useDataContext();

  const pathName = usePathname();
  const { user: WPUser } = useWPUser();
  const [error, setError] = useState<string | null>(null); // Add an error state

  // Determine if current page is a specific route
  const videoPage = pathName.includes("public");
  const homePage = pathName === "/";
  const blogPage = pathName.includes("blog");
  const usersPage = pathName.includes("users");
  const authorAvatarSrc =
    currentProjectInfo?.avatarUri || currentProjectInfo?.logoUrl || ""; // Fallback to logoUrl if avatarUri is not available

  console.log(currentProjectInfo);

  // If share menu is not open, render the navigation menu
  if (!shareMenuOpen) {
    return (
      <div className="ml-auto gap-2 items-center flex">
        {homePage && <RegisterDownloadButton />}
        {" "}
        {
          !videoPage && <ThemeChooser orientation="horizontal" />
          //  null
        }
        {/* Conditional rendering based on WP user authentication status */}
        {!WPUser && (
          <>
            {/* Blog Page: Show Login button if WP user is not authenticated */}
            {homePage ? null : blogPage ? (
              WPUser ? null : null // </> //   </Button> //     <Link href="/users/create">Create Blog</Link> //   <Button variant="secondary" asChild> //   </Button> //     <Link href="/users/login">Login</Link> //   <Button variant="secondaryOutline" asChild> // <>
            ) : !videoPage ? (
              // If not on the video or users page, show Register / Download button
              usersPage ? null : (
                <RegisterDownloadButton className="-mr-2" />
              )
            ) : (
              <>
                <div
                  className={cn(
                    !error
                      ? "!text-green-500 dark:!text-green-200"
                      : "text-red-500 dark:text-red-200",
                    "!ml-auto p-0 !w-auto px-2 gap-2 items-center flex gap-3",
                  )}
                >
                  {error ? (
                    <AlertTriangle />
                  ) : //   <CheckCircleIcon />
                  null}
                </div>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      className={cn(
                        "flex gap-2 items-center text-xs bg-transparent",
                        currentProjectInfo.authorName && "min-w-32",
                      )}
                    >
                      {currentProjectInfo && (
                        <Avatar
                          className={cn(
                            "h-6 w-6 ",
                            currentProjectInfo.authorName && "-ml-1",
                          )}
                        >
                          <AvatarImage
                            src={authorAvatarSrc}
                            alt={currentProjectInfo.authorName}
                          />
                          <GenericAvatarFallback />
                        </Avatar>
                      )}
                      <span className="relative -top-px">
                        {currentProjectInfo?.authorName}
                      </span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align={"end"} className="border-none">
                    <DropdownMenuGroup>
                      <DropdownMenuItem>
                        {currentProjectInfo ? (
                          <Link
                            className="w-full [&>button]:w-full"
                            href={`/store/${currentProjectInfo.authorId}`}
                          >
                            <Button
                              variant={"ghost"}
                              className="flex items-center gap-3 text-left justify-start"
                            >
                              <Store size={15} />{" "}
                              <p className="truncate">Merchandise Store</p>
                            </Button>
                          </Link>
                        ) : (
                          <Button className="flex items-center gap-3 justify-center">
                            <Icons.spinner className="h-4 w-4 animate-spin" />
                          </Button>
                        )}
                      </DropdownMenuItem>
                    </DropdownMenuGroup>
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            )}
          </>
        )}
        {/* Right-aligned menu with settings and WP authentication */}
        <div className={cn("h-full flex items-center")}>
          {/* Render SettingMenu component with videoPage prop */}
          <div className="overflow-hidden w-0 h-0">
            {/* <ThemeTabs orientation="horizontal" /> */}
          </div>
          <SettingMenu videoPage={videoPage} />
          {/* Render WPAuthMenu component */}
        </div>
      </div>
    );
  } else {
    // Return null if share menu is open, meaning no right navigation menu
    return null;
  }
}
